const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+Profile+API

function updateProfile(profileData) {
    const url = '/api/users/profile';

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(profileData)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = updateProfile;
